import './Workspace.svelte.css';
/* src/components/Workspace.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	add_render_callback,
	add_transform,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_animation,
	create_component,
	create_in_transition,
	create_out_transition,
	destroy_component,
	detach,
	element,
	empty,
	fix_and_outro_and_destroy_block,
	fix_position,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_keyed_each
} from "../../_snowpack/pkg/svelte/internal.js";

import { flip } from "../../_snowpack/pkg/svelte/animate.js";
import { quintInOut } from "../../_snowpack/pkg/svelte/easing.js";
import { crossfade } from "../../_snowpack/pkg/svelte/transition.js";
import { expressionStore } from "./stores.js";
import Formula from "./Formula.svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (30:0) {#each workspaceItems as item (item.expression.identifier)}
function create_each_block(key_1, ctx) {
	let div;
	let formula;
	let t;
	let div_id_value;
	let div_intro;
	let div_outro;
	let rect;
	let stop_animation = noop;
	let current;
	formula = new Formula({ props: { wsItem: /*item*/ ctx[4] } });

	return {
		key: key_1,
		first: null,
		c() {
			div = element("div");
			create_component(formula.$$.fragment);
			t = space();
			attr(div, "class", "formula svelte-mus8r3");
			attr(div, "id", div_id_value = /*item*/ ctx[4].expression.identifier);
			this.first = div;
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(formula, div, null);
			append(div, t);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const formula_changes = {};
			if (dirty & /*workspaceItems*/ 1) formula_changes.wsItem = /*item*/ ctx[4];
			formula.$set(formula_changes);

			if (!current || dirty & /*workspaceItems*/ 1 && div_id_value !== (div_id_value = /*item*/ ctx[4].expression.identifier)) {
				attr(div, "id", div_id_value);
			}
		},
		r() {
			rect = div.getBoundingClientRect();
		},
		f() {
			fix_position(div);
			stop_animation();
			add_transform(div, rect);
		},
		a() {
			stop_animation();
			stop_animation = create_animation(div, rect, flip, { duration: 200 });
		},
		i(local) {
			if (current) return;
			transition_in(formula.$$.fragment, local);

			add_render_callback(() => {
				if (!current) return;
				if (div_outro) div_outro.end(1);

				div_intro = create_in_transition(div, /*receive*/ ctx[2], {
					key: /*item*/ ctx[4].expression.identifier
				});

				div_intro.start();
			});

			current = true;
		},
		o(local) {
			transition_out(formula.$$.fragment, local);
			if (div_intro) div_intro.invalidate();

			div_outro = create_out_transition(div, /*send*/ ctx[1], {
				key: /*item*/ ctx[4].expression.identifier
			});

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(formula);
			if (detaching && div_outro) div_outro.end();
		}
	};
}

function create_fragment(ctx) {
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_1_anchor;
	let current;
	let each_value = /*workspaceItems*/ ctx[0];
	const get_key = ctx => /*item*/ ctx[4].expression.identifier;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*workspaceItems*/ 1) {
				each_value = /*workspaceItems*/ ctx[0];
				group_outros();
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].r();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, fix_and_outro_and_destroy_block, create_each_block, each_1_anchor, get_each_context);
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].a();
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d(detaching);
			}

			if (detaching) detach(each_1_anchor);
		}
	};
}

function getSortedItems(storeValues) {
	const items = Array.from(storeValues);
	items.sort((left, right) => left.position - right.position);
	return items;
}

function instance($$self, $$props, $$invalidate) {
	let $expressionStore;
	component_subscribe($$self, expressionStore, $$value => $$invalidate(3, $expressionStore = $$value));
	let workspaceItems;

	const [send, receive] = crossfade({
		duration: d => Math.sqrt(d * 200),
		fallback(node, params) {
			const style = getComputedStyle(node);
			const transform = style.transform === "none" ? "" : style.transform;

			return {
				duration: 200,
				easing: quintInOut,
				css: t => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`
			};
		}
	});

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$expressionStore*/ 8) {
			$: $$invalidate(0, workspaceItems = getSortedItems($expressionStore.values()));
		}
	};

	return [workspaceItems, send, receive, $expressionStore];
}

class Workspace extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Workspace;